<template>
  <v-card min-width="300" width="500"  outlined>
    <v-card-title class="py-3 justify-center">
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-card-text class="pa-3 text-center justify-center">
      <p>{{ description }}</p>
      <p>{{ validateEmail }}</p>
      <div class="d-flex justify-center mt-4">
        <v-btn
          v-if="type === 'NOT_ACTIVATED'"
          class="mr-3"
          @click="goToConfirmEmail"
          >{{ messageBtn }}</v-btn
        >
        <v-btn @click="close">{{
          $t(type === "NOT_ACTIVATED" ? "closeBtn" : "understoodBtn")
        }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LoginError",
  props: {
    type: String,
    email: String,
    password: String,
  },
  data() {
    return {
      title: "",
      description: "",
      messageBtn: "",
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    type() {
      this.init();
    },
  },
  methods: {
    init() {
      if (this.type === "NOT_ACTIVATED") {
        this.title = this.$t("notActivated.title");
        this.description = this.$t("notActivated.description");
        this.messageBtn = this.$t("notActivated.messageBtn");
      } else if (this.type === "NOT_CREDENTIALS") {
        this.title = this.$t("notCredentials.title");
        this.description = this.$t("notCredentials.description");
      } else {
        this.title = this.$t("unexpected.title");
        this.description = this.$t("unexpected.description");
      }
    },
    goToConfirmEmail() {
      this.$router.push({
        name: "confirmed-email",
        params: {
          email: this.email,
          password: this.password,
          comeFrom: "LoginError",
        },
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.theme--light.v-btn,
.theme--dark.v-btn {
  &.v-btn--has-bg.button-login-error {
    background-color: var(--v-mainGreen-base);
    border-radius: 3px;
    padding: 5% 7.7% !important;
  }
}
</style>


